<template>
  <div class="lazy-image-container" :style="{ aspectRatio: props.aspectRatio }">
    <img
      :src="imageUrl"
      :alt="altText"
      :class="imageClass"
      :width="width"
      :height="height"
      :style="imageStyle"
      :loading="loading"
      :fetchpriority="fetchpriority"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  imageUrl: {
    type: String,
    required: true
  },
  altText: {
    type: String,
    required: true
  },
  aspectRatio: {
    type: String,
    required: false,
    default: 'auto'
  },
  width: {
    type: Number,
    required: false,
    default: undefined
  },
  height: {
    type: Number,
    required: false,
    default: undefined
  },
  imageClass: {
    type: String,
    default: ''
  },
  loading: {
    type: String,
    default: 'lazy',
    validator: value => ['lazy', 'eager'].includes(value)
  },
  fetchpriority: {
    type: String,
    default: undefined,
    validator: value =>
      value === undefined || ['high', 'low', 'auto'].includes(value)
  }
})

const imageStyle = computed(() => {
  const style = {}

  if (!props.width && !props.height) {
    style.width = '100%'
    style.height = '100%'
  }

  return style
})
</script>

<style lang="scss" scoped>
.lazy-image-container {
  overflow: hidden;

  img {
    object-fit: cover;
    display: block;
  }
}
</style>
